module.exports = __webpack_public_path__ + "img/triple.d2f2987.svg";